import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./scss/style.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import App from "./App.tsx";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { MyProvider } from "./context/MyContext";
import { SocratesV2Provider } from "./context/SocratesV2Context";
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

Sentry.init({
  // [11179] Sentry 과금 최적화를 위해 이벤트 수집 중단 (향후 재적용 검토 예정)
  enabled: false,
  dsn: "https://5c49bbf97d4578bd8be7402be36a9193@o4508917818392576.ingest.us.sentry.io/4508990441062400",
  replaysOnErrorSampleRate: 0.3,
  replaysSessionSampleRate: 0.2,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5분간 fresh 상태 유지
      refetchOnWindowFocus: false, // 탭 포커스 시 자동 refetch 비활성화
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Router>
        <MyProvider>
          <SocratesV2Provider>
            <App />
          </SocratesV2Provider>
        </MyProvider>
      </Router>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
